export enum CARTRIDGE_STATE {
    insertedSide = '-inserted-side',
    insertedTop = '-inserted-top',
    face = '-face',
    isometric = '-isometric',
}
